import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import FileUploader_V2 from "@/components/FileUploader_V2/FileUploader_V2";
import { useTranslation } from "@i18n";
import stl from "./UploadOfferAttachments.module.css";
import { useEffect, useState } from "react";
import { trackEvents } from "@/common/events/events";
import toast from "react-hot-toast";
import { api__uploadAttachments } from "@/apis/orderTracking/uploadDocs";
import useHelpers from "@hooks/useHelpers";
import useLocalStorage from "@hooks/useLocalStorage";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { CDN_LINK } from "@globalConfig";
import HorizontalCarCard from "@/components/sharedComponents/HorizontalCarCard/HorizontalCarCard";
import { api__getRecentlyViewedPostsData } from "@/apis/recentlyViewed/api__getRecentlyViewedPostsData";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import Loader from "@componentsShared/Loader/Loader";
import useButtonLoading, { dispatchButtonLoading } from "@hooks/useButtonLoading";
import { twMerge } from "tailwind-merge";
var UploadOfferAttachments = function UploadOfferAttachments(_ref) {
  var _details$step_body6, _details$step_body6$f, _details$step_body7, _details$step_body7$f, _details$step_body7$f2;
  var details = _ref.details,
    fileObjects = _ref.fileObjects,
    preSignData = _ref.preSignData,
    uploadDocumentsData = _ref.uploadDocumentsData,
    orderId = _ref.orderId,
    onFileChange = _ref.onFileChange,
    buttonLoading = _ref.buttonLoading,
    deleteFileObject = _ref.deleteFileObject,
    setFileObjects = _ref.setFileObjects,
    deleteDocuments = _ref.deleteDocuments,
    stepNum = _ref.stepNum,
    isFinance = _ref.isFinance,
    g4_data = _ref.g4_data,
    _ref$dontCheckFiles = _ref.dontCheckFiles,
    dontCheckFiles = _ref$dontCheckFiles === void 0 ? false : _ref$dontCheckFiles,
    customText = _ref.customText,
    _ref$hideTitle = _ref.hideTitle,
    hideTitle = _ref$hideTitle === void 0 ? false : _ref$hideTitle,
    _ref$freeFinanceFunct = _ref.freeFinanceFunctionality,
    freeFinanceFunctionality = _ref$freeFinanceFunct === void 0 ? false : _ref$freeFinanceFunct,
    _ref$upcomingFiles = _ref.upcomingFiles,
    upcomingFiles = _ref$upcomingFiles === void 0 ? [] : _ref$upcomingFiles,
    updateLoader = _ref.updateLoader,
    mobileNUmberForEvent = _ref.mobileNUmberForEvent,
    _ref$sendFormSubmitEv = _ref.sendFormSubmitEvent,
    sendFormSubmitEvent = _ref$sendFormSubmitEv === void 0 ? false : _ref$sendFormSubmitEv,
    InformParentPopUpIsOpen = _ref.InformParentPopUpIsOpen,
    _ref$isArib = _ref.isArib,
    isArib = _ref$isArib === void 0 ? false : _ref$isArib;
  var _useTranslation = useTranslation(["web_tracking"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var internalButtonLoading = useButtonLoading();
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var _useState2 = useState(false),
    userUploadedFiles = _useState2[0],
    setUserUploadedFiles = _useState2[1];
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  var _useAribFinance$actio = useAribFinance().actions,
    action__getPostID = _useAribFinance$actio.action__getPostID,
    action__updateDataAfterSubmit = _useAribFinance$actio.action__updateDataAfterSubmit;
  var helper__paymentEnabled = useAribFinance().helpers.helper__paymentEnabled;
  var _useState3 = useState(null),
    carDetailes = _useState3[0],
    setCarDetailes = _useState3[1];
  useEffect(function () {
    ShowPopUp === true && InformParentPopUpIsOpen(true);
  }, [ShowPopUp]);
  useEffect(function () {
    var carsIds = {
      post_id: action__getPostID(),
      view_date: "12356"
    };
    api__getRecentlyViewedPostsData([carsIds], 1).then(function (res) {
      setCarDetailes(res === null || res === void 0 ? void 0 : res.data[0]);
    });
  }, []);
  var uploadFiles = function uploadFiles() {
    var queryParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    sendFormSubmitEvent && triggerEvent();
    dispatchButtonLoading(true);
    api__uploadAttachments(fileObjects, preSignData, uploadDocumentsData, orderId, stepNum, isFinance).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var checkoutUrl;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            orderUploadEvent();
            if (typeof queryParam !== "string") {
              queryParam = "";
            }
            _context.n = 1;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 500);
            });
          case 1:
            if (!freeFinanceFunctionality) {
              checkoutUrl = isFinance ? "/tracking-finance-details/".concat(orderId).concat(queryParam) : "/tracking-checkout-details/".concat(orderId);
              navigateTo(checkoutUrl);
            } else {
              setShowPopUp(true);
              dispatchButtonLoading(false);
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })))["catch"](function (error) {
      dispatchButtonLoading(false);
      toast.dismiss();
      toast.error(error.message);
    });
  };
  var triggerEvent = function triggerEvent() {
    var _g4_data;
    var submission_source = getSubmissionSource();
    var eventPayload = _objectSpread(_objectSpread({}, g4_data), {}, {
      inventory_type_string: (_g4_data = g4_data) === null || _g4_data === void 0 ? void 0 : _g4_data.inventory_type_string,
      order_id: orderId,
      payment_option: null,
      payment_status: null,
      response_message: null,
      response_code: null,
      referral_location: submission_source,
      finance_type: "free"
    });
    if (isArib && !helper__paymentEnabled() || !isArib) {
      trackEvents("finance_order_submit", _objectSpread({}, eventPayload));
    }
  };
  var orderUploadEvent = function orderUploadEvent() {
    var _details$step_body, _details$step_body$fi, _details$step_body2, _details$step_body2$f, _g4_data2;
    var computedG4Data = Object.keys(fileObjects).length === (details === null || details === void 0 ? void 0 : (_details$step_body = details.step_body) === null || _details$step_body === void 0 ? void 0 : (_details$step_body$fi = _details$step_body.fields) === null || _details$step_body$fi === void 0 ? void 0 : _details$step_body$fi.values.filter(function (obj) {
      return obj.file === null;
    }).length) && (details === null || details === void 0 ? void 0 : (_details$step_body2 = details.step_body) === null || _details$step_body2 === void 0 ? void 0 : (_details$step_body2$f = _details$step_body2.fields) === null || _details$step_body2$f === void 0 ? void 0 : _details$step_body2$f.values.every(function (obj) {
      return obj.file !== null;
    })) === false ? _objectSpread(_objectSpread({}, g4_data), {}, {
      status: "true"
    }) : g4_data;
    g4_data = !dontCheckFiles ? computedG4Data : g4_data;
    trackEvents("order_document_upload", _objectSpread(_objectSpread({}, (_g4_data2 = g4_data) !== null && _g4_data2 !== void 0 ? _g4_data2 : details === null || details === void 0 ? void 0 : details.g4_data), {}, {
      document_id_type: Object.keys(preSignData)
    }));
  };
  var handleSubmit = function handleSubmit() {
    var queryParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    !freeFinanceFunctionality && uploadFiles(queryParam);
    !freeFinanceFunctionality && sendFormSubmitEvent && triggerEvent();
  };
  var getButtonDetails = function getButtonDetails(fileObjects, details) {
    var _details$step_body3, _details$step_body3$f, _details$step_body3$f2, _details$step_body4, _details$step_body4$f, _details$step_body4$f2, _details$step_body5, _details$step_body5$f, _details$step_body5$f2;
    var nullFileCount = details === null || details === void 0 ? void 0 : (_details$step_body3 = details.step_body) === null || _details$step_body3 === void 0 ? void 0 : (_details$step_body3$f = _details$step_body3.fields) === null || _details$step_body3$f === void 0 ? void 0 : (_details$step_body3$f2 = _details$step_body3$f.values) === null || _details$step_body3$f2 === void 0 ? void 0 : _details$step_body3$f2.filter(function (obj) {
      return obj.file === null;
    }).length;
    var hasRejectedFiles = details === null || details === void 0 ? void 0 : (_details$step_body4 = details.step_body) === null || _details$step_body4 === void 0 ? void 0 : (_details$step_body4$f = _details$step_body4.fields) === null || _details$step_body4$f === void 0 ? void 0 : (_details$step_body4$f2 = _details$step_body4$f.values) === null || _details$step_body4$f2 === void 0 ? void 0 : _details$step_body4$f2.filter(function (obj) {
      return obj.status === "rejected";
    }).length;
    var isAllFilesNull = Object.keys(fileObjects).length === nullFileCount && (details === null || details === void 0 ? void 0 : (_details$step_body5 = details.step_body) === null || _details$step_body5 === void 0 ? void 0 : (_details$step_body5$f = _details$step_body5.fields) === null || _details$step_body5$f === void 0 ? void 0 : (_details$step_body5$f2 = _details$step_body5$f.values) === null || _details$step_body5$f2 === void 0 ? void 0 : _details$step_body5$f2.every(function (obj) {
      return obj.file !== null;
    })) === false;
    var hasRejectedAllFiles = Object.keys(fileObjects).length === hasRejectedFiles;
    var buttonText = isAllFilesNull || hasRejectedFiles ? customText ? customText : t("upload_files", {
      ns: "web_tracking"
    }) : customText ? customText : t("upload_files", {
      ns: "web_tracking"
    });
    var buttonClassName = isAllFilesNull || hasRejectedAllFiles ? "".concat(stl.uploadDocButton, " ").concat(stl.sendFilesButton) : "".concat(stl.uploadDocButton, " ").concat(stl.saveButton);
    var isDisabled = Object.keys(fileObjects).length === 0;
    return {
      text: buttonText,
      className: buttonClassName,
      isDisabled: isDisabled,
      hasRejectedFiles: hasRejectedFiles
    };
  };
  var _getButtonDetails = getButtonDetails(fileObjects, details),
    text = _getButtonDetails.text,
    className = _getButtonDetails.className,
    isDisabled = _getButtonDetails.isDisabled,
    hasRejectedFiles = _getButtonDetails.hasRejectedFiles;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.uploadContainer
  }, !hideTitle && /*#__PURE__*/React.createElement("h3", {
    className: stl.uploadDocTitle
  }, details === null || details === void 0 ? void 0 : (_details$step_body6 = details.step_body) === null || _details$step_body6 === void 0 ? void 0 : (_details$step_body6$f = _details$step_body6.fields) === null || _details$step_body6$f === void 0 ? void 0 : _details$step_body6$f.title), details === null || details === void 0 ? void 0 : (_details$step_body7 = details.step_body) === null || _details$step_body7 === void 0 ? void 0 : (_details$step_body7$f = _details$step_body7.fields) === null || _details$step_body7$f === void 0 ? void 0 : (_details$step_body7$f2 = _details$step_body7$f.values) === null || _details$step_body7$f2 === void 0 ? void 0 : _details$step_body7$f2.map(function (field, idx) {
    return /*#__PURE__*/React.createElement(FileUploader_V2, {
      key: idx,
      onFileChange: onFileChange,
      dbFile: field,
      details: details,
      index: idx,
      deleteFileObject: deleteFileObject,
      setFileObjects: setFileObjects,
      deleteDocuments: deleteDocuments,
      orderId: orderId,
      stepNum: stepNum,
      buttonLoading: buttonLoading,
      isFinance: isFinance,
      g4_data: g4_data,
      isPreFilledData: (field === null || field === void 0 ? void 0 : field.file) != null
    });
  }), !freeFinanceFunctionality && /*#__PURE__*/React.createElement("div", {
    className: stl.conditionsList
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.uploadCondition
  }, "- ", t("accepted_formats_pdf_jpeg_png", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.uploadCondition
  }, "-", " ", t("validation_file_size_exceed_5_mb", {
    ns: "web_tracking"
  }))), freeFinanceFunctionality && /*#__PURE__*/React.createElement("hr", {
    className: stl.freeFinanceFunctionalityDivider
  }), freeFinanceFunctionality && (upcomingFiles === null || upcomingFiles === void 0 ? void 0 : upcomingFiles.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: stl.hasUpcomingFilesContainer
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("strong", null, t("validation_documents_required_later", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("ul", null, upcomingFiles.map(function (file, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx
    }, "- ", file);
  })))), !freeFinanceFunctionality && /*#__PURE__*/React.createElement(SubmitButton, {
    onClick: handleSubmit,
    type: "submit",
    disabled: isDisabled || buttonLoading,
    loading: buttonLoading,
    className: className
  }, text), freeFinanceFunctionality && /*#__PURE__*/React.createElement("div", {
    className: stl.submintButtonsContainer
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      uploadFiles("?showmyAcc=1");
      setUserUploadedFiles(true);
      document.body.style.overflow = "hidden";
    },
    className: [className, "relative"].join(" "),
    disabled: isDisabled || buttonLoading,
    loading: buttonLoading
  }, t("submit_request", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: twMerge("w-[318px] p-3 h-auto text-[#6c7a8d] text-base font-bold leading-6 border border-[#6c7a8d] bg-white relative", isArib && "border border-primary border-solid text-primary"),
    onClick: function onClick() {
      setUserUploadedFiles(false);
      document.body.style.overflow = "hidden";
      setShowPopUp(true);
    },
    disabled: buttonLoading,
    loading: buttonLoading
  }, t("attach_files_later", {
    ns: "web_tracking"
  })))), freeFinanceFunctionality && ShowPopUp && /*#__PURE__*/React.createElement("div", {
    className: "fixed flex flex-col sm:flex-row items-start justify-start sm:justify-center pb-10 gap-[22px] w-full h-full left-0 top-0 z-[9] bg-[#fafcff] py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-10 md:shadow-[0_0_10px_rgb(188_188_188_/_0.4)] flex flex-col gap-[24px] items-center justify-center w-[85%] mt-[90px] relative p-0 border-none sm:w-full sm:p-[32px_24px] sm:rounded-xl sm:border sm:border-solid sm:border-[#EBF0F7] sm:bg-white sm:min-w-[520px] sm:max-w-[520px] mx-auto"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/GreenTickIcon.svg",
    width: "98px",
    height: "81px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#0d0db5] text-center text-2xl font-bold leading-8"
  }, userUploadedFiles && t("congrats_application_submitted", {
    ns: "web_tracking"
  }), !userUploadedFiles && t("request_information_filled", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#0d0db5] text-center text-base font-medium leading-6 w-[85%]"
  }, userUploadedFiles && t("follow_request_attach_remaining_documents", {
    ns: "web_tracking"
  }), !userUploadedFiles && t("validation_track_request_attach_required_documents", {
    ns: "web_tracking"
  })), carDetailes && /*#__PURE__*/React.createElement(HorizontalCarCard, {
    isEager: false,
    post: carDetailes,
    wrapperClassName: "pointer-events-none [&>*]:pointer-events-none",
    showGrantedPopup: function showGrantedPopup() {
      return false;
    },
    hideMarkitingLabel: true,
    hideFavIcon: true
  }), /*#__PURE__*/React.createElement("button", {
    className: ["relative flex w-full items-center justify-center h-12 rounded text-white text-base font-bold leading-6", internalButtonLoading ? "pointer-events-none bg-[#EBF0F7] border-0" : "blueBtn"].join(" "),
    onClick: function onClick() {
      dispatchButtonLoading(true);
      action__updateDataAfterSubmit({
        postId: action__getPostID(),
        isOrderSubmited: true
      });
      if (userUploadedFiles) {
        var _useLocalStorage = useLocalStorage(),
          getLocalStorage = _useLocalStorage.getLocalStorage,
          removeLocalStorage = _useLocalStorage.removeLocalStorage;
        var referral_location = getLocalStorage("referral_location") || "";
        var from_car_comparison = referral_location === "car_comparison";
        if (from_car_comparison) {
          removeLocalStorage("referral_location");
        }
        navigateTo("/tracking-finance-details/".concat(orderId));
      } else if (!userUploadedFiles) {
        dispatchButtonLoading(false);
        navigateTo("/tracking-finance-details/".concat(orderId));
      }
    }
  }, t("proceed_track_request", {
    ns: "web_tracking"
  }), internalButtonLoading && /*#__PURE__*/React.createElement(Loader, {
    className: "!bg-transparent !absolute w-full h-full m-0 [zoom:0.6] [backdrop-filter:blur(1px)]"
  })))), internalButtonLoading && /*#__PURE__*/React.createElement(Loader, null));
};
export default UploadOfferAttachments;